export const USER_ROLE = "user";
export const APP_ADMIN_ROLE = "appAdmin";
export const RESTAURANT_ADMIN_ROLE = "restaurantAdmin";